import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { useCategories } from "../../hooks/database";
import usePremiumTrial from "../../hooks/usePremiumTrial";
import useAuth from "../../hooks/useAuth";

import CardCategoriaDesafios from "../../components/desafiosPicantes/cardCategoria";
import NovaCategoriaDesafios from "../../components/desafiosPicantes/novaCategoria";

import Header, {
  HomeHeaderLeft,
  NoHeaderScroll,
} from "../../components/navigation/header";
import Spinner from "../../components/utils/spinner";

function HeaderCenter() {
  const { t } = useTranslation();
  return <h1 className="text-lg font-extrabold">{t("choosecategory")}</h1>;
}

export default function CategoriasDesafios() {
  const [selected, setSelected] = useState([]);
  const [categories] = useCategories();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { canPlay, showPremiumModal, showBlockModal } = usePremiumTrial();
  const { user } = useAuth();

  const handleSelect = (index) => {
    if (selected.includes(index)) {
      setSelected(selected.filter((item) => item !== index));
    } else {
      setSelected([...selected, index]);
    }
  };

  const handleNewCategory = () => {
    if (user?.isPremium) {
      navigate("/hot-challenges/player-categories");
    } else {
      showPremiumModal();
    }
  };

  const handleContinue = () => {
    let allowed = true;

    if (user?.isPremium) {
      allowed = true;
    } else {
      for (let i = 0; i < selected.length; i++) {
        const item = selected[i];
        if (typeof item === "string" && item.includes("|")) {
          // Item é uma categoria personalizada, sem premium não pode jogar
          allowed = false;
          break;
        }
        const category = categories.find((cat) => cat.id === item);

        if (!category?.is_free) {
          // Item é uma categoria premium, sem premium só pode jogar se ainda tiver créditos
          allowed = canPlay("desafios");
          break;
        }
      }
    }

    if (allowed) {
      navigate("/hot-challenges/pre-game", {
        state: { selected: selected.sort() },
      });
    } else {
      showBlockModal();
    }
  };

  return (
    <div className="container no-scroll mx-auto">
      <Header
        HeaderLeft={HomeHeaderLeft}
        HeaderCenter={HeaderCenter}
        HeaderRight={() => <div></div>}
      />
      <NoHeaderScroll className={"h-[calc(100%-72px-76px)] p-5"}>
        {categories.length ? (
          <div className="grid grid-cols-2 gap-4">
            {categories.map((item, index) => {
              let id = item.id;
              if (item.id_categoria) {
                id = `|${item.id_categoria}|`;
              }
              return (
                <CardCategoriaDesafios
                  key={`category-${item.index}`}
                  index={index}
                  id={id}
                  label={item.label}
                  image={item.image}
                  selected={selected.includes(id)}
                  onClick={handleSelect}
                />
              );
            })}
            <NovaCategoriaDesafios
              animation={
                categories.length % 2 ? "slide-in-right" : "slide-in-left"
              }
              onClick={handleNewCategory}
            />
          </div>
        ) : (
          <div className="flex justify-center">
            <Spinner />
          </div>
        )}
      </NoHeaderScroll>
      <div className="m-10 mb-4 mt-4">
        <button
          disabled={selected.length === 0}
          type="button"
          onClick={handleContinue}
          className="btn btn-brand btn-small pt-2 pb-2 w-full"
        >
          {t("start")}
        </button>
      </div>
    </div>
  );
}
